import { Grid } from '@mui/material';
import { ReactNode } from 'react';
import Copyright from '../copyright';
import './style.css';

const Wrapper = ({ children }: { children: ReactNode }) => {
    return (
        <Grid
            className="bgWrapper"
            container
            direction="column"
            justifyContent={'space-between'}
            sx={{
                height: '100%',
                minHeight: '100vh'
            }}
        >
            <Grid>{children}</Grid>
            <Grid container direction="row" padding={'8px 16px'} flexWrap={'wrap'} alignItems={'center'} justifyContent={'center'} sx={{ maxWidth: '1920px', color: '#FFF' }}>
                <Grid>
                    <Copyright />{' '}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Wrapper;
